import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import { withRouter } from 'react-router-dom';


import { api_host, api_auth } from '../../../../../common/globals/constants';
import {getDetalleDisponibilidadGlobalObjetivo} from '../../../../../services/getDetalleDisponibilidadGlobalObjetivo'
import PortletContent from 'components/PortletContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';
import moment from 'moment'
import 'moment/locale/es'  
moment.locale('es')


class AvailabilityStep extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            currentObjectiveId: this.props.match.params.objetivo_id,
            prevObjectiveId: this.props.match.params.objetivo_id,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'h',
            node: null,
            hoverData: null,
            lastEvent: [],
            statePeriod: this.props.params.statePeriod,
            isStatePeriod: false,
            chartOptionsBase: this._chartOptionsBase,
            chartOptions: this._chartOptionsBase,
            isRefresh: this.props.params.isRefresh,
            date:this.props.params.date,
            dateMoment:((moment().locale('es')).format("dddd, DD/MM/YYYY, h:mm:ss a"))

        }
  
    }
    _chartOptionsBase = {
        chart: {
            type: 'column'
        },
        title: {
            text: '',
            style: {
                fontSize: '' 
             }
        },
        subtitle: {
            text: '',
            style: {
                color: '',
                fontWeight: ''
            }
        },
        xAxis: {
            categories: [""],
            labels: {
                rotation: -45,
            },
            title: {
                text: null,
            },
            labels: {
                enabled: true,
                rotation:-45,
            },

        },
        plotOptions: {
            series: {
                dataLabels: {
                    enabled: true
                }
            }
        },
        yAxis: {
            min: 0,
            max: 100,
            title: {
                text: null,
            },
            labels: {
                enabled: false
            },
            gridLineWidth: 0,
        },
        legend: {
            enabled: false
        },
        tooltip: {
            enabled: false,
            pointFormat: 'Tiempo de respuesta: <b>{point.y:.2f} (s)</b>'
        },
        credits: {
            enabled: false
        },
        series: [
        ]
    };

    setHoverData = (e) => {
        const { x, y, series, index } = e.target

        // The chart is not updated because `chartOptions` has not changed.
        let point = []
        point['x'] = series.xAxis.categories[index]
        //point['x'] = "series.userOptions.category[index]"
        point['y'] = y
        let step = series.userOptions.name
        this.props.params.onInfo(point, step)
    }

    static getDerivedStateFromProps(props, state) {
        if (props.match.params.objetivo_id !== state.prevObjectiveId) {
            return {
                chartOptions: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
            }
        } else if (props.params.period !== state.time) {
            return {
                chartOptions: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isStatePeriod: props.params.isStatePeriod
            }
        } else if (props.params.node !== state.node) {
            return {
                chartOptions: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: state.time,
                node: props.params.node,
                lastEvent: [],
                dataError: false,
                isLoading: true,
                hoverData: null,
                statePeriod: props.params.statePeriod
            }
        } else if ((props.params.period === state.time) && (props.params.statePeriod !== state.statePeriod)) {
            return {
                chartOptions: state.chartOptionsBase,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                hoverData: null,
                isLoading: true,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isStatePeriod: props.params.isStatePeriod
            }
        } else if(props.params.isRefresh !== state.isRefresh){
            return {
                chartOptions: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isRefresh: props.params.isRefresh,          
            }

        } else if(props.params.date !== state.date){
            return {
                chartOptions: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                date: props.params.date,          
            }

        }
        return null;
    }


    componentDidMount() {
        this.getDataFromAPI();
    }

    componentDidUpdate(prevProps, prevState) {
        if((prevProps.params.isRefresh !== this.state.isRefresh) && this.state.dateMoment!==((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a"))){
            this.props.params.onDateMoment(((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")))
        }
        if ((prevProps.params.period !== this.state.time) ||
            (prevProps.match.params.objetivo_id !== this.props.match.params.objetivo_id) ||
            (prevProps.params.node !== this.state.node) ||
            (prevProps.params.statePeriod !== this.state.statePeriod) ||
            (prevProps.params.isRefresh !== this.state.isRefresh)||
            (prevProps.params.date !== this.state.date)) {
            this.getDataFromAPI();
        }

    }
    componentWillUnmount() {

    }

    getDataFromAPI = (objectiveId) => {
        const { objetivo_id } = this.props.match.params
        const { fromObjective } = this.props.location.state
        const { period, statePeriod, node} = this.props.params
        const { history } = this.props;

        let sla_rendimiento_ok = parseInt(fromObjective.sla_rendimiento_ok)
        let sla_rendimiento_error = parseInt(fromObjective.sla_rendimiento_error)
        let sla_disponibilidad_ok = parseInt(fromObjective.sla_disponibilidad_ok)
        let sla_disponibilidad_error = parseInt(fromObjective.sla_disponibilidad_error)
        let fecha_inicio = null
        let fecha_termino = null
        let token = sessionStorage.getItem('key')
        let user = sessionStorage.getItem('user')
        let time = 'w'
        if (this.state.period !== 'w') {
            time = 'd'
        }
        if (period === 'c') {
            fecha_inicio = statePeriod.startDate.toISOString().substring(0, 10)
            fecha_termino = statePeriod.endDate.toISOString().substring(0, 10)
            fetch(api_host+`/reporte/online/indicadores/getDetalleDisponibilidadGlobalObjetivoCustom/?objetivoId=${objetivo_id}&horarioId=0&token=${token}&key=${api_auth}&fechaInicio=${fecha_inicio}&fechaTermino=${fecha_termino}&nodoId=${node}`)
                .then(response => response.json())
                .then(myJson => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (myJson.status == 1 || myJson.status == 5) {
                        localStorage.setItem('isAuthenticated', false);                        
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(myJson, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                period,
                                fecha_inicio,
                                fecha_termino)
                            if (this.state.lastEvent !== []) {
                                this.props.params.onFirstInfo(this.state.lastEvent)
                            }
                        } catch (error) {
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }
                });
        } else {
                getDetalleDisponibilidadGlobalObjetivo(objetivo_id, node, period, token)
                .then(myJson => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa
                    if (myJson.status == 1 || myJson.status == 5) {
                        localStorage.setItem('isAuthenticated', false);                        
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(myJson, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                period,
                                fecha_inicio,
                                fecha_termino)
                            if (this.state.lastEvent !== []) {
                                this.props.params.onFirstInfo(this.state.lastEvent)
                            }
                        } catch (error) {
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }

                });

        }
    }

    // Helper para procesar la data de la petición a la API

    processData = (externalData,
        sla_rendimiento_ok,
        sla_rendimiento_error,
        sla_disponibilidad_ok,
        sla_disponibilidad_error,
        period,
        fecha_inicio,
        fecha_termino) => {

        let lastEventDict = []
        let chartTitle = "Disponibilidad Global Por paso"
        let chartCategory = []
        let chartSerieUp = []
        let chartSerieDown = []
        let chartSerieParcial = []
        let chartSerieNoMon = []
        let chartSerieEventClient = []

        let rowLen = externalData.Objetivo.Paso.length
        externalData.Objetivo.Paso.forEach((element, forEachKey) => {
            chartCategory.push(element.paso_nombre)
            let eventup = 0
            let down = 0
            let parcial = 0
            let noMon = 0
            let event = 0
            element.estado.forEach((estados) => {
                let dateHasta = (new Date(estados.fecha_hasta))
                let dateDesde = (new Date(estados.fecha_desde))
                let result = dateHasta - dateDesde
                if (estados.nombre === "uptime") {
                    eventup = eventup + result
                } else if (estados.nombre === "downtime") {
                    down = down + result
                } else if (estados.nombre === "no monitoreo") {
                    noMon = noMon + result
                }else if (estados.nombre === "evento cliente") {
                    event = event + result
                } else {
                    parcial = parcial + result
                }
            })
            let total = eventup + down + parcial + noMon +event
            eventup = eventup * 100 / total
            down = down * 100 / total
            parcial = parcial * 100 / total
            noMon = noMon * 100 / total
            event=event * 100 / total
            chartSerieUp.push(parseFloat(eventup.toFixed(2)))
            chartSerieDown.push(parseFloat(down.toFixed(2)))
            chartSerieParcial.push(parseFloat(parcial.toFixed(2)))
            chartSerieNoMon.push(parseFloat(noMon.toFixed(2)))
            chartSerieEventClient.push(parseFloat(event.toFixed(2)))
            //console.log(eventup, down, parcial, noMon)
            if (forEachKey == (rowLen - 1)){
                //lastEventDict['x'] = Date.UTC(year,(month),day,hours,minutes,seconds)
                lastEventDict['x'] = element.paso_nombre
                lastEventDict['y'] = parseFloat(eventup.toFixed(2));
                lastEventDict['name'] =  'uptime';
                if (period === 'h') {
                    lastEventDict['namePeriod'] = 'Rango: última hora'
                } else if (period === 'd') {
                    lastEventDict['namePeriod'] = 'Rango: último día'
                } else if (period === 'w') {
                    lastEventDict['namePeriod'] = 'Rango: última semana'
                } else if (period === 'c') {
                    lastEventDict['namePeriod'] = 'Rango: ' + fecha_inicio + ' a ' + fecha_termino
                }
            }
        });

        this.setState({
            chartOptions: {
                plotOptions: {
                    series: {
                        point: {
                            events: {
                                mouseOver: this.setHoverData.bind(this)
                            }
                        }
                    }
                },
                xAxis: {
                    categories:chartCategory
                },
                yAxis: {
                    plotLines: [{
                        value: sla_disponibilidad_ok,
                        color: '#54a51c',
                        width: 2,
                        zIndex: 3
                    }, {
                        value: sla_disponibilidad_error,
                        color: '#D22129',
                        width: 2,
                        zIndex: 3
                    }]
                },
               
                series: [
                    {
                        name: "uptime",
                        color: "#41B900",
                        data: chartSerieUp
                    },
                    {
                        name: "downtime",
                        color: "#C2272D",
                        data: chartSerieDown
                    },
                    {
                        name: "Parcial",
                        color: "#FFC600",
                        data: chartSerieParcial
                    },
                    {
                        name: "No Monitoreo",
                        color: "#A9A9A9",
                        data: chartSerieNoMon
                    },
                    {
                        name: "Mantenimiento",
                        color: "#1976d2",
                        data: chartSerieEventClient
                    },
                ]
            },
            dataError: false,
            isLoading: false,
            lastEvent: lastEventDict,
            time: period,
            chartOptionsBase: {
                ...this._chartOptionsBase,
                xAxis: {
                    ...this._chartOptionsBase.xAxis,
                    categories: chartCategory
                },
                yAxis: {
                    ...this._chartOptionsBase.yAxis,
                    plotLines: [{
                        value: sla_disponibilidad_ok,
                        color: '#54a51c',
                        width: 2,
                        zIndex: 3
                    }, {
                        value: sla_disponibilidad_error,
                        color: '#D22129',
                        width: 2,
                        zIndex: 3
                    }]
                },
                series: [
                    {
                        name: "uptime",
                        color: "#41B900",
                        data: chartSerieUp
                    },
                    {
                        name: "downtime",
                        color: "#C2272D",
                        data: chartSerieDown
                    },
                    {
                        name: "Parcial",
                        color: "#FFC600",
                        data: chartSerieParcial
                    },
                    {
                        name: "No Monitoreo",
                        color: "#A9A9A9",
                        data: chartSerieNoMon
                    },
                    {
                        name: "Mantenimiento",
                        color: "#1976d2",
                        data: chartSerieEventClient
                    },
                ]
            }
        });


    }
    render() {
        const { dataError, chartOptions, isLoading,chartOptionsBase } = this.state;
        const style = isLoading ? { display: 'none' } : {};
        const styleHidden = isLoading ? {} : { display: 'none' };

        if (!dataError) {
            sessionStorage.setItem("chartAvailabilityStep",JSON.stringify(chartOptionsBase))
            return (<FormattedChart chartOptions={chartOptions} style={style} styleHidden={styleHidden} />)
        }
        else if (dataError) {
            return (<p>No hay datos..</p>)
        }
        else return (<p> Error!</p >)

    }
}

function FormattedChart(props) {

    return (
        <div >
            <div style={props.styleHidden}>
            <PortletContent>
                <PerfectScrollbar>

                    <Typography
                      variant="h5"
                    >
                     <CircularProgress
                      variant="indeterminate"

                      size={24}
                      thickness={4}
                      
                    />
                    <br/>
                     Cargando Información...
                   </Typography>
                  </PerfectScrollbar>
            </PortletContent>
            </div>
            <div style={props.style}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={props.chartOptions} />
            </div>
        </div>
    )
}


export default withRouter(AvailabilityStep);